import { FC } from 'react';
import packageInfo from '../../../package.json';
interface CopyRightProps {
  isShowVersion: boolean;
}
const CopyRight: FC<CopyRightProps> = ({ isShowVersion }) => (
  <div className="copyright">
    <div
      className="copyright-url"
      onClick={() => {
        window.open('https://www.slotcheck.com', '_blank');
      }}
    >
      www.slotcheck.com
    </div>
    <div className="copy-right">
      <div className="copyright-name">Slot Check, Inc. &copy; 2026</div>
      {isShowVersion && <div className="copyright-version">Version {packageInfo.version}</div>}
    </div>
  </div>
);

export default CopyRight;
